/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-22.
 * Form configuration for tabulador
 */
import {
    AUTOCOMPLETE,
    DATE,
    SELECT,
    TEXT,
    FILE
} from '../components/data-containers/formBuilder/types';

const dataForSelects = {
    items: [
        { id: 'customId1', name: 'Data 1' },
        { id: 'customId2', name: 'Data 2' }
    ],
    displayProp: (item) => item.name
};


export const getConfig = (actions) => {
    return {
        fields: [
            {
                fType: TEXT,
                key: 'imphonorarios',
                floatingLabelFixed: true,
                floatingLabelText: 'Honoarios 1',
                hintText: '% minimo',
            },
            {
                fType: TEXT,
                key: 'imphonorarios2',
                floatingLabelFixed: true,
                floatingLabelText: 'Honoarios 2',
                hintText: 'por Caja / Plataforma / LTL',
            },
            {
                fType: TEXT,
                key: 'impcomplementarios',
                floatingLabelFixed: true,
                floatingLabelText: 'Complementarios',
                hintText: 'por Contenedor',
            },
            {
                fType: TEXT,
                key: 'exphonorarios',
                floatingLabelFixed: true,
                floatingLabelText: 'Honoarios 1',
                hintText: '% minimo',
            },
            {
                fType: TEXT,
                key: 'exphonorarios2',
                floatingLabelFixed: true,
                floatingLabelText: 'Honoarios 2',
                hintText: 'por Contenedor',
            },
            {
                fType: TEXT,
                key: 'expcomplementarios',
                floatingLabelFixed: true,
                floatingLabelText: 'Complementarios',
                hintText: 'por Contenedor',
            },
            {
                fType: TEXT,
                key: 'fpedimentoyvalid',
                floatingLabelFixed: true,
                floatingLabelText: 'Fecha de Pedimento y Validacion',
                hintText: 'por Pedimento',
            },
            {
                fType: TEXT,
                key: 'previoocular',
                floatingLabelFixed: true,
                floatingLabelText: 'Previo Ocular',
                hintText: 'por Pedimento',
            },
            {
                fType: TEXT,
                key: 'documentacion',
                floatingLabelFixed: true,
                floatingLabelText: 'Documentacion',
                hintText: 'por Embarque',
            },
            {
                fType: TEXT,
                key: 'documentacion',
                floatingLabelFixed: true,
                floatingLabelText: 'Documentacion',
                hintText: 'por Embarque',
            },
            {
                fType: SELECT,
                key: 'tipo',
                floatingLabelText: 'Tipo',
                floatingLabelFixed: true,
                data: dataForSelects,
                value: '' //must be the id
            },
            {
                fType: TEXT,
                key: 'algo',
                floatingLabelFixed: true,
                floatingLabelText: 'Algo',
                hintText: 'Ferromex',
            },
            {
                fType: SELECT,
                key: 'algo2',
                floatingLabelText: 'Algo 2',
                floatingLabelFixed: true,
                data: dataForSelects,
                value: '' //must be the id
            },
        ],
        sections: [
            { title: 'Importacion', keys: ['imphonorarios', 'imphonorarios2', 'impcomplementarios'] },
            { title: 'Exportacion', keys: ['exphonorarios', 'exphonorarios2', 'expcomplementarios'] },
            { title: 'Gastos Aplicables a la importacion, exportacion y Operaciones Especiales',
                 keys: ['fpedimentoyvalid', 'previoocular', 'documentacion'] },
        ],
        rules: {
            proveedor: [{ key: 'required', errorText: 'Campo requerido' }],
            tipo: [{ key: 'required', errorText: 'Campo requerido' }]
        }
    };
};



// WEBPACK FOOTER //
// ./forms/tabulador.js